@if (order) {
    <div (click)="onBackdropClick($event)" (keydown.escape)="close()" class="order-modal-backdrop" tabindex="-1">
        <article aria-modal="true" class="order-modal" role="dialog">
        <header class="order-modal-header">
            <div><span>{{ 'Order details' | translate }}</span><strong>{{ getOrderIdentifier(order) }}</strong></div>
            <button (click)="close()" [attr.aria-label]="'Close order details' | translate" class="modal-close"
                    type="button">
                <i class="material-icons">close</i>
            </button>
        </header>
        <div class="order-modal-body">
            <div class="details-column">
                <section class="detail-panel">
                    <h2>{{ 'Summary' | translate }}</h2>
                    <div class="detail-grid">
                        <div>
                            <span>{{ 'Status' | translate }}</span><strong
                                [appOrderStatus]="getOrderStatus(order)">{{ getOrderStatus(order) | translate }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Platform' | translate }}</span><strong>{{ getOrderSource(order) | translate }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Created' | translate }}</span><strong>{{ getEntryDate(order) | date:'dd.MM.yyyy HH:mm:ss' }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Closed' | translate }}</span><strong>{{ getCloseDate(order) | date:'dd.MM.yyyy HH:mm:ss' }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Accepted' | translate }}</span><strong>{{ (getOrderDate(order, 'OrderAcceptedEntryDate') | date:'dd.MM.yyyy HH:mm:ss') || '-' }}</strong>
                        </div>
                        <div>
                            <span>{{ 'First proposal' | translate }}</span><strong>{{ (getOrderDate(order, 'FirstCarProposalDate') | date:'dd.MM.yyyy HH:mm:ss') || '-' }}</strong>
                        </div>
                        <div><span>{{ 'Price' | translate }}</span><strong>{{ getPrice(order) }}</strong></div>
                        <div><span>{{ 'Distance' | translate }}</span><strong>{{ getDistance(order) }}</strong></div>
                        <div><span>{{ 'Billable time' | translate }}</span><strong>{{ getDuration(order) }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Service type' | translate }}</span><strong>{{ getServiceValue(order, 'ServiceType') | translate }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Destination type' | translate }}</span><strong>{{ getServiceValue(order, 'Destination') | translate }}</strong>
                        </div>
                    </div>
                </section>
                <section class="detail-panel">
                    <h2>{{ 'Client and request' | translate }}</h2>
                    <div class="detail-grid">
                        <div><span>{{ 'Name' | translate }}</span><strong>{{ getClientName(order) }}</strong></div>
                        <div><span>{{ 'Phone' | translate }}</span><strong>
                            @if (getClientPhone(order) !== '-') {
                                <a [href]="'tel:' + getClientPhone(order)">
                                    {{ getClientPhone(order) }}</a>
                            }
                            @if (getClientPhone(order) === '-') {
                                -
                            }
                        </strong></div>
                        <div><span>{{ 'Email' | translate }}</span><strong>{{ getClientEmail(order) }}</strong></div>
                        <div>
                            <span>{{ 'App version' | translate }}</span><strong>{{ getRequestValue(order, 'AppVer') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Device ID' | translate }}</span><strong>{{ getRequestValue(order, 'DeviceId') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'External order ID' | translate }}</span><strong>{{ getRequestValue(order, 'ExternalSystemOrderId') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Airport order' | translate }}</span><strong>{{ formatBoolean($safeNavigationMigration(getRequest(order)?.IsAirportOrder)) | translate }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Phone order' | translate }}</span><strong>{{ formatBoolean($safeNavigationMigration(getRequest(order)?.IsClassicPhoneOrder)) | translate }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Office order' | translate }}</span><strong>{{ formatBoolean($safeNavigationMigration(getRequest(order)?.IsOfficeOrder)) | translate }}</strong>
                        </div>
                        <div>
                            <span>Drink Safe</span><strong>{{ formatBoolean($safeNavigationMigration(getRequest(order)?.IsDrinkSafeOrder)) | translate }}</strong>
                        </div>
                    </div>
                </section>
                <section class="detail-panel">
                    <h2>{{ 'Car and driver' | translate }}</h2>
                    <div class="detail-grid">
                        <div><span>{{ 'Assigned car' | translate }}</span><strong>{{ getCarDisplay(order) }}</strong>
                        </div>
                        <div><span>{{ 'Driver ETA' | translate }}</span><strong>{{ getDriverEta(order) }}</strong></div>
                        <div>
                            <span>{{ 'Car identifier' | translate }}</span><strong>{{ getCarDisplay(order) }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Car number' | translate }}</span><strong>{{ getCarValue(order, 'CarNumber') }}</strong>
                        </div>
                        <div><span>{{ 'Model' | translate }}</span><strong>{{ getCarValue(order, 'CarModel') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Company' | translate }}</span><strong>{{ getCompanyDisplay(order) }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Driver' | translate }}</span><strong>{{ getDriverValue(order, 'DriverName') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Driver ID' | translate }}</span><strong>{{ getDriverValue(order, 'DriverIdentifier') }}</strong>
                        </div>
                        <div>
                            <span>{{ 'Driver phone' | translate }}</span><strong>{{ getDriverValue(order, 'DriverPhone') }}</strong>
                        </div>
                    </div>
                </section>
                <section class="detail-panel">
                    <h2>{{ 'Route' | translate }}</h2>
                    <div class="route-list">
                        @for (point of routePoints; track point) {
                            <div
                                    [class.destination]="point.type === 'destination'"
                                    [class.pickup]="point.type === 'pickup'"
                                    [class.stop]="point.type === 'stop'" class="route-point">
                                <span class="route-point-marker">{{ point.marker }}</span>
                                <div class="route-point-copy">
                                    <span>{{ point.label | translate }}</span><strong>{{ point.formattedAddress }}</strong>
                                    @if (point.address.Comments) {
                                        <small>{{ point.address.Comments }}</small>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </section>
            </div>
            <section class="detail-panel map-panel">
                <div class="map-panel-heading">
                    <h2>{{ 'Map' | translate }}</h2>
                    @if (isRouteLoading) {
                        <span><i
                                class="material-icons spinning">refresh</i> {{ 'Loading recorded route' | translate }}</span>
                    }
                    @if (!isRouteLoading && taximeterPoints.length > 0) {
                        <span>
        {{ taximeterPoints.length }} {{ 'recorded points' | translate }}
                            @if (interactiveTaximeterPoints.length < taximeterPoints.length) {
                                - {{ interactiveTaximeterPoints.length }} {{ 'interactive' | translate }}
                            }
      </span>
                    }
                    @if (routeLookupComplete && !isRouteLoading && taximeterPoints.length === 0
                    && routeLoadError === '') {
                        <span>{{ 'No recorded route' | translate }}</span>
                    }
                    @if (routeLoadError !== '') {
                        <span class="route-load-error">{{ routeLoadError | translate }}</span>
                    }
                </div>
                @if (hasMapData()) {
                    <div [class.route-tooltip-open]="isRouteTooltipOpen" class="order-map">
                        <google-map #orderRouteMap (idle)="fitOrderMapBounds()" [center]="mapCenter"
                                    [options]="mapOptions" [zoom]="mapZoom"
                                    height="100%" width="100%">
                            @if (taximeterPoints.length === 0) {
                                <map-polyline
                                        [options]="addressPolylineOptions" [path]="mapMarkers">
                                </map-polyline>
                            }
                            @if (taximeterPoints.length > 1) {
                                <map-polyline
                                        [options]="taximeterPolylineOptions" [path]="taximeterPoints">
                                </map-polyline>
                            }
                            @for (marker of mapMarkers; track marker) {
                                <map-advanced-marker #routeMapMarker="mapAdvancedMarker"
                                                     (gmpClick)="openOrderMarkerInfo(routeMapMarker, marker)"
                                                     [content]="marker.content"
                                                     [gmpClickable]="true"
                                                     [position]="marker.position"
                                                     [title]="marker.title"
                                                     [zIndex]="marker.zIndex">
                                </map-advanced-marker>
                            }
                            <map-info-window #routeMarkerInfo>
                                @if (selectedMapMarker) {
                                    <strong>{{ selectedMapMarker.title | translate }}</strong>
                                }
                            </map-info-window>
                            @for (point of interactiveTaximeterPoints; track point) {
                                <map-advanced-marker #routePointMarker="mapAdvancedMarker"
                                                     (mapMouseout)="hideRoutePointInfo()"
                                                     (mapMouseover)="showRoutePointInfo(routePointMarker, point)"
                                                     [content]="point.content"
                                                     [gmpClickable]="true"
                                                     [position]="point.position"
                                                     [zIndex]="point.zIndex">
                                </map-advanced-marker>
                            }
                            <map-info-window #routePointInfo [options]="routePointInfoOptions">
                                @if (selectedRoutePoint) {
                                    <div class="taximeter-point-info">
                                        @if (selectedRoutePoint.isFallbackDestination) {
                                            <strong>
                                                {{ 'Destination' | translate }}
                                            </strong>
                                        }
                                        <strong>{{ selectedRoutePoint.localTimestamp | date:'dd.MM.yyyy HH:mm:ss' }}</strong>
                                        <span>{{ 'Speed' | translate }}:
                                            {{ formatRouteSpeed(selectedRoutePoint.speed) }}</span>
                                    </div>
                                }
                            </map-info-window>
                        </google-map>
                    </div>
                }
                @if (!hasMapData()) {
                    <div class="map-empty">
                        <i class="material-icons">location_off</i><span>{{ 'No route coordinates are stored for this order.' | translate }}</span>
                    </div>
                }
            </section>
        </div>
    </article>
</div>
}
